export default class CreateProjectFormulationCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, GlobalSrv) {
    var createProjectFormulationVm = this
    const texts = GlobalConfig.appTexts
    const currentUser = JSON.parse($cookies.get('currentUser'))
    const post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId
    }

    // VARIABLES
    createProjectFormulationVm.isEditing = Boolean($stateParams.workplanTeacherActivityId)
    createProjectFormulationVm.rolList = []
    createProjectFormulationVm.financialArray = []
    createProjectFormulationVm.typeFinancial = []
    createProjectFormulationVm.isTouchedfinancials = false
    createProjectFormulationVm.createOrEdit = 'Crear'
    createProjectFormulationVm.textCreateOrEdit = texts.saved
    createProjectFormulationVm.createOrEditMV = texts.createDialog
    createProjectFormulationVm.active = GlobalConfig.generals.active
    createProjectFormulationVm.notActive = GlobalConfig.generals.notActive
    $scope.classPlanning = ''
    createProjectFormulationVm.notification = createProjectFormulationVm.notActive
    createProjectFormulationVm.rangeType = GlobalConfig.periods.rangeType
    createProjectFormulationVm.periodsArray = []
    createProjectFormulationVm.typePeriod = []
    createProjectFormulationVm.isTouchedPeriods = false
    createProjectFormulationVm.selectedTypePeriod = {}
    createProjectFormulationVm.selectedTypeFinancial = {}
    createProjectFormulationVm.startDate = null
    createProjectFormulationVm.endDate = null
    createProjectFormulationVm.minStartDate = moment().toDate()
    createProjectFormulationVm.minEndDate = new Date()
    createProjectFormulationVm.buttonDisabled = false
    createProjectFormulationVm.isFeedback = currentUser.isFeedback
    createProjectFormulationVm.$cookies = $cookies

    createProjectFormulationVm.dt_start = $cookies.get('wp_start')
    createProjectFormulationVm.dt_end = $cookies.get('wp_end')

    // //METHODS
    createProjectFormulationVm.validateForm = validateForm
    createProjectFormulationVm.showErrorMessages = showErrorMessages
    createProjectFormulationVm.hasError = hasError
    createProjectFormulationVm.startDateChange = startDateChange
    createProjectFormulationVm.funSelectedFinancial = funSelectedFinancial
    createProjectFormulationVm.validateCheklistFinancials = validateCheklistFinancials
    createProjectFormulationVm.funSelectedPeriod = funSelectedPeriod
    createProjectFormulationVm.validateCheklistPeriods = validateCheklistPeriods
    createProjectFormulationVm.close = close
    createProjectFormulationVm.addProject = addProject
    createProjectFormulationVm.cleanRangeType = cleanRangeType

    createProjectFormulationVm.updateRangeType = (val) => {
      createProjectFormulationVm.rangeType = val
      createProjectFormulationVm.periodsArray = []
      createProjectFormulationVm.startDate = null
      createProjectFormulationVm.endDate = null
    }
    createProjectFormulationVm.updateRangeData = (val) => {
      createProjectFormulationVm.periodsArray = val['periods']
      createProjectFormulationVm.startDate = val['dates'][0]
      createProjectFormulationVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createProjectFormulationVm.isEditing) {
        createProjectFormulationVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createProjectFormulationVm.activityId = GlobalConfig.minorActivityId.project
        createProjectFormulationVm.createOrEdit = 'Editar'
        createProjectFormulationVm.createOrEditMV = texts.editDialog
        createProjectFormulationVm.textCreateOrEdit = texts.modified
        getDataProject()
      }

      WorkPlanSrv.getListProjectsFormulated.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn)
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function showErrorMessages (input) {
      if (input) {
        return input.$dirty || input.$touched
      } else {
        return false
      }
    }

    function hasError (input) {
      if (input && input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function validateForm (form) {
      return (form && form.$invalid) ||
             createProjectFormulationVm.validateCheklistPeriods()
    }

    function loadData (data) {
      createProjectFormulationVm.rolList = data.listRoles.items
      createProjectFormulationVm.typeFinancial = data.listFinancial
      createProjectFormulationVm.typePeriod = data.listPeriods
      updateView()
    }

    function updateView () {
      createProjectFormulationVm.viewLoaded = false
      $timeout(() => {
        createProjectFormulationVm.viewLoaded = true
      }, 1)
    }

    function funSelectedFinancial (financial, checked) {
      if (checked) {
        if (!createProjectFormulationVm.financialArray.includes(financial.financialId)) {
          createProjectFormulationVm.financialArray.push(financial.financialId)
        }
      } else {
        let index = createProjectFormulationVm.financialArray.indexOf(financial.financialId)
        if (index != -1) {
          createProjectFormulationVm.financialArray.splice(index, 1)
        }
      }
      createProjectFormulationVm.isTouchedfinancials = true
    }

    function validateCheklistFinancials () {
      return (createProjectFormulationVm.rangeType > 0 ? createProjectFormulationVm.financialArray.length < 1 : false)
    }

    function startDateChange () {
      let m = moment(createProjectFormulationVm.startDate)
      createProjectFormulationVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function validateCheklistPeriods () {
      return (createProjectFormulationVm.rangeType == 1 ? createProjectFormulationVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createProjectFormulationVm.periodsArray.includes(period.periodId)) {
          createProjectFormulationVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createProjectFormulationVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createProjectFormulationVm.periodsArray.splice(index, 1)
        }
      }
      createProjectFormulationVm.isTouchedPeriods = true
    }

    function close () {
      $mdDialog.hide()
    }

    function addProject (isExecution) {
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function createJson (origin) {
      var project = {
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        name: createProjectFormulationVm.title,
        summary: createProjectFormulationVm.projectSummary,
        hoursPlanning: createProjectFormulationVm.plannedHours,
        activityId: GlobalConfig.minorActivityId.project,
        roleId: createProjectFormulationVm.rol,
        notification: createProjectFormulationVm.notification,
        timeRangeTypeId: createProjectFormulationVm.rangeType,
        origin: origin,
        isFeedbackActivity: createProjectFormulationVm.isFeedback
      }

      // Financiadores
      var arrayFinancial = []
      for (var index in createProjectFormulationVm.financialArray) {
        var temp = {
          financialId: createProjectFormulationVm.financialArray[index]
        }
        arrayFinancial.push(temp)
      }
      project.financial = arrayFinancial

      if (createProjectFormulationVm.isEditing) {
        project.workplanTeacherActivityId = createProjectFormulationVm.workplanTeacherActivityId
      }

      if (parseInt(createProjectFormulationVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createProjectFormulationVm.periodsArray) {
          var temp = {
            periodId: createProjectFormulationVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        project.periods = arrayPeriod
      } else {
        project.startDate = (createProjectFormulationVm.startDate != null) ? createProjectFormulationVm.startDate : createProjectFormulationVm.project.startDate
        project.endDate = (createProjectFormulationVm.endDate != null) ? createProjectFormulationVm.endDate : createProjectFormulationVm.project.endDate
      }
      addOrEditProject(project)
    }

    function getSendNotify () {
      const nameUser = currentUser.dsFullname
      const idTeacher = currentUser.teacherId
      const msg = 'El profesor ' + nameUser + ' ha registrado una formulación de proyecto'
      const notificationName = 'Notificación, El profesor ' + nameUser + ' ha registrado una formulación de proyecto'
      const groupedNotification = 1

      const dataInbox = {
        idTeacher: idTeacher,
        dsName: notificationName,
        dsDescription: msg,
        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
        is_grouped: groupedNotification
      }

      const dataEmail = {
        idTeacher: idTeacher,
        dsName: notificationName,
        dsDescription: msg,
        idNotification_delivery_type: GlobalConfig.notificationType.email,
        is_grouped: groupedNotification
      }

      const secondData = {
        idTeacher: idTeacher,
        dsName: 'Notificación, se ha registrado actividades en investigación',
        dsDescription: 'El profesor ' + nameUser + ' ha registrado actividades en investigación',
        idNotification_delivery_type: GlobalConfig.notificationType.email,
        is_grouped: groupedNotification
      }

      GlobalSrv.sendNotificationsEvaluatorsSubmodule(dataInbox)
      GlobalSrv.sendNotificationsEvaluatorsSubmodule(dataEmail)
      GlobalSrv.sendNotificationsEvaluatorsSubmodule(secondData)
    }

    function addOrEditProject (project) {
      createProjectFormulationVm.buttonDisabled = true
      WorkPlanSrv.addProjectFormulated.save(project).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          confirmProjectAction()
          getSendNotify()
        } else {
          createProjectFormulationVm.buttonDisabled = false
        }
      })
    }

    function confirmProjectAction () {
      const header = {
        createOrEdit: createProjectFormulationVm.createOrEditMV,
        textCreateOrEdit: createProjectFormulationVm.textCreateOrEdit,
        itemName: createProjectFormulationVm.title,
        nameModal: texts.modalTypeName.projectFormulation,
        modalType: texts.modalTypeId.projectFormulation
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header)
    }

    function getDataProject () {
      const data = {
        workplanTeacherActivityId: parseInt(createProjectFormulationVm.workplanTeacherActivityId),
        activityId: parseInt(createProjectFormulationVm.activityId)
      }
      WorkPlanSrv.getProjectsFormulated.get(data).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createProjectFormulationVm.project = dataReturn.project[0]
          setValues(createProjectFormulationVm.project)
        } else {
          console.log('Comunications problem with the server')
        }
      })
    }

    function setValues (project) {
      const dateValueSetter = (date) => moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').toDate() : null
      createProjectFormulationVm.title = project.nameProject
      createProjectFormulationVm.rol = project.roleId
      createProjectFormulationVm.projectSummary = project.summary
      createProjectFormulationVm.rangeType = project.timeRangeTypeId
      createProjectFormulationVm.dt_start = dateValueSetter(project.startDate)
      createProjectFormulationVm.dt_end = dateValueSetter(project.endDate)
      createProjectFormulationVm.plannedHours = project.hoursPlanning
      createProjectFormulationVm.periodsArray = []
      createProjectFormulationVm.selectedTypePeriod = {}
      createProjectFormulationVm.financialArray = []
      createProjectFormulationVm.selectedTypeFinancial = {}
      createProjectFormulationVm.notification = Boolean(project.isNotification === 1)

      if (createProjectFormulationVm.rangeType === GlobalConfig.periods.rangeType) {
        createProjectFormulationVm.periodsArray = project.periodId.split(',').map(id => {
          createProjectFormulationVm.selectedTypePeriod[Number(id)] = true
          return Number(id)
        })
      }

      if (project.financialId != null) {
        createProjectFormulationVm.financialArray = project.financialId.split(',').map(id => {
          createProjectFormulationVm.selectedTypeFinancial[Number(id)] = true
          return Number(id)
        })
      }

      if (project.startDate) {
        var startDateNew = moment(project.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createProjectFormulationVm.minStartDate = moment(project.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createProjectFormulationVm.isEditing = true
    }

    function cleanRangeType () {
      if (parseInt(createProjectFormulationVm.rangeType) == GlobalConfig.periods.rangeType) {
        createProjectFormulationVm.startDate = null
        createProjectFormulationVm.endDate = null
      } else {
        createProjectFormulationVm.periodsArray = []
        createProjectFormulationVm.selectedTypePeriod = null
      }
    }
  }// FIN DEL CONSTRUCTOR

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateProjectFormulationCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/projectsFormulation/createProjectFormulation/createProjectFormulationCtrl.js